import { render, staticRenderFns } from "./CampaignItemName.vue?vue&type=template&id=39868615&scoped=true&"
import script from "./CampaignItemName.vue?vue&type=script&lang=js&"
export * from "./CampaignItemName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39868615",
  null
  
)

export default component.exports